import React, { Fragment } from 'react';

import * as Actions from 'notifications_config/components/list/actions';

const NotificationsConfigActions = ({
  permissions,
  notificationConfig,
  company,
  subcompany,
  handleToggle,
}) => {
  return (
    <Fragment>
      {permissions['acl.notifications_config.toggle'] && (
        <Actions.Toggle notificationConfig={notificationConfig} handleClick={handleToggle} />
      )}
      {permissions['acl.notifications_config.update'] && (
        <Actions.Edit
          notificationConfig={notificationConfig}
          company={company}
          subcompany={subcompany}
        />
      )}
    </Fragment>
  );
};

export default NotificationsConfigActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/list/NotificationsConfigActions.js